module.exports = __webpack_public_path__ + "static/media/eduaction-material.9bc51077.png";